import { Component } from '@angular/core';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss']
})
export class DisclaimerComponent {

  content = `The developer of this website and the Insider Trading Alerts Chrome extension is not registered as a securities broker - dealer or an investment
advisor either with the U.S. Securities and Exchange Commission (the 'SEC') or with any state securities regulatory authority.
He is neither licensed nor qualified to provide investment advice.<br><br>

  DO NOT BASE ANY INVESTMENT DECISION UPON ANY INFORMATION FOUND ON THIS
  WEBSITE OR IN THE CHROME EXTENSION. PLEASE BE ADVISED THAT YOUR CONTINUED USE OF THIS WEBSITE AND/OR CHROME EXTENSION OR THE INFORMATION PROVIDED HEREIN SHALL INDICATE YOUR
  CONSENT AND AGREEMENT TO THESE TERMS.<br><br>

The information contained in this website and in the Insider Trading Alerts Chrome extension is neither an offer nor a recommendation to buy or
sell securities. Any information found in this website and Chrome extension is not provided to any particular individual
with a view toward their individual circumstances. This website and the Chrome extension have been prepared for informational
purposes only and is not intended to be used as a complete source of information
on any particular company. An individual should never invest in the securities of any of the
companies’ listed based solely on information contained in this website and the Chrome extension. Individuals should
assume that all information contained in this website and the Chrome extension is not trustworthy unless verified by their own
independent research. Please note that occasionally SEC filing forms are filled in incorrectly.
We will not be responsible for the success or
failure of any individual or entity which implements information received from this website and the Chrome extension.

We do not provide any assurance as to the accuracy or completeness of the information provided. To the
fullest extent of the law, we will not be liable to any person or entity for the quality,
accuracy, completeness, reliability, or timeliness of the information provided in this
website and the Chrome extension, or for any direct, indirect, consequential, incidental, special or punitive damages that may arise
out of the use of information we provide to any person or entity (including, but not limited to,
lost profits, loss opportunities, trading losses, and damages that may result from any
inaccuracy or incompleteness of this information).<br><br>

WE DO NOT IMPLY, PREDICT, OR GUARANTEE THAT YOU WILL BE SUCCESSFUL IN EARNING ANY MONEY
WHATSOEVER. IF YOU RELY UPON ANY FIGURES OR INFORMATION ON THIS WEBSITE OR THE CHROME EXTENSION, YOU MUST ACCEPT THE
RISK OF SUBSTANTIAL LOSSES.`;


}
